<template>
  <v-icon
    v-if="typeof state === 'boolean'"
    :color="state ? 'success' : 'error'"
  >
    {{ state ? 'check' : 'block' }}
  </v-icon>
  <span v-else>
    -
  </span>
</template>

<script>
export default {
  name: 'KernelPackageReturnState',

  props: {
    state: {
      type: [Boolean, null, undefined],
      default: undefined,
    },
  },
};
</script>
